import { Stack, SxProps, Theme } from '@mui/material'
import cofinanciadoUe from '../../assets/images/cofinanciado-ue.png'
import comunidadDeMadrid from '../../assets/images/comunidad-de-madrid.png'

interface FundingLogosProps {
  size?: 'small' | 'default'
  direction?: 'row' | 'column'
  sx?: SxProps<Theme>
}

export default function FundingLogos({
  size = 'default',
  direction = 'row',
  sx
}: FundingLogosProps) {
  const madridHeight = size === 'small' ? '3rem' : '4.5rem'
  const ueHeight = size === 'small' ? '3rem' : '4.5rem'

  return (
    <Stack
      direction={direction}
      alignItems='center'
      justifyContent='center'
      spacing='1.5rem'
      sx={sx}
    >
      <img
        alt='Comunidad de Madrid'
        src={comunidadDeMadrid}
        style={{ height: madridHeight }}
      />
      <img
        alt='Cofinanciado por la Unión Europea'
        src={cofinanciadoUe}
        style={{ height: ueHeight }}
      />
    </Stack>
  )
}
